import qs from 'querystring';

export const bannerEngagementAdapter = (queryString: string): string =>
  qs.parse(queryString).banner ? `banner=${qs.parse(queryString).banner}` : '';
